import { AxiosError } from 'axios';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { AppForm, AppFormProps } from 'components/organisms';
import { PayUCredentialsAddEditFormFields } from 'types';
import { FormNavButtons, SimpleInputElement } from 'components/molecules';
import { commonTexts, settingsTexts } from 'consts/text/index';
import { formFields } from 'consts/form/formFields';
import { payUCredentialsAddEditErrorParser } from 'utils/errorHandlers/payUCredentials/payUCredentialsAddEditErrorParser';

export type PayUCredentialsAddEditFormProps = Omit<
    AppFormProps<PayUCredentialsAddEditFormFields>,
    'width' | 'title' | 'name' | 'onFinish' | 'error' | 'withGoBack'
> & {
    axiosError?: AxiosError | null;
    isLoading?: boolean;
    onFinish: (payUCredentialsAddEditFormFields: PayUCredentialsAddEditFormFields) => void;
};

export const PayUCredentialsAddEditForm = ({
    initialValues,
    axiosError,
    form,
    ...props
}: PayUCredentialsAddEditFormProps) => {
    const payUCredentialsAddEditError = axiosError
        ? payUCredentialsAddEditErrorParser(axiosError)
        : '';

    const isAddMode = !initialValues;

    return (
        <AppForm<PayUCredentialsAddEditFormFields>
            form={form}
            title={
                isAddMode
                    ? settingsTexts.payUCredentials.form.addModeTitle
                    : settingsTexts.payUCredentials.form.editModeTitle
            }
            name="payUCredentialsAddEdit"
            withGoBack
            error={payUCredentialsAddEditError}
            {...props}
        >
            <SimpleInputElement
                name={formFields.pointOfSaleId}
                label={settingsTexts.payUCredentials.details.labels.saleIdPoint}
                placeholder="Podaj id punktu płatności"
            />
            <SimpleInputElement
                name={formFields.secondKey}
                label={settingsTexts.payUCredentials.details.labels.secondKey}
                placeholder="Podaj drugi klucz"
            />
            <SimpleInputElement
                name={formFields.clientId}
                label={settingsTexts.payUCredentials.details.labels.clientId}
                placeholder="Podaj client_id"
            />
            <SimpleInputElement
                name={formFields.clientSecret}
                label={settingsTexts.payUCredentials.details.labels.clientSecret}
                placeholder="Podaj client_secret"
            />
            <FormNavButtons
                formValuesBeforeChanges={initialValues}
                buttonText={
                    isAddMode ? commonTexts.actionLabels.add : commonTexts.actionLabels.save
                }
                withPlus={isAddMode}
                leftIcon={!isAddMode ? <IconDeviceFloppy size={20} /> : undefined}
            />
        </AppForm>
    );
};
